import React from 'react'
import { connect } from 'react-redux'
import { RigipsStore } from 'redux/redux'
import { Query } from 'react-apollo'
import { NavLink, matchPath, withRouter, RouteComponentProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CompanyInfo, MANUFACTURERS_QUERY } from 'pages/manufacturers'

import get from 'lodash/get'
import { getManufacturer } from 'utils'

import NavItem from './navItem'

import LogoAbk from 'images/logo-abk.svg'
import LogoRigips from 'images/logo-rigips.svg'

interface IProps extends RouteComponentProps {
  authenticated?: boolean
}

const Navigation: React.FC<IProps> = ({ authenticated, history }) => {
  const { t } = useTranslation()

  const pathMatches = (path: string) =>
    Boolean(
      matchPath(history.location.pathname, {
        path: path,
        exact: true,
      }),
    )

  const showManufacturer =
    process.env.REACT_APP_ENV === 'abk' &&
    (pathMatches('/projects/:projectId/new-calculation') ||
      pathMatches('/calculations/new-calculation') ||
      pathMatches('/calculations/:calculationId') ||
      pathMatches('/projects/:projectId/calculations/:calculationId'))

  return (
    <header className="h-75 px-48 flex justify-between items-center relative t-0 l-0 r-0 z-5">
      <div className="flex items-center">
        <NavLink to="/">
          <img
            style={{ height: 40 }}
            src={process.env.REACT_APP_ENV === 'rigips' ? LogoRigips : LogoAbk}
            alt="Logo"
            aria-hidden="true"
          />
        </NavLink>

        {showManufacturer && (
          <Query query={MANUFACTURERS_QUERY} fetchPolicy="network-only" notifyOnNetworkStatusChange>
            {({ loading, data }: any | null) => {
              if (loading) return null

              const manufacturers = get(data, 'getCompanies', [])
              const currentManufacturer = manufacturers.find(
                (manufacturer: CompanyInfo) => manufacturer.id === getManufacturer(),
              )

              if (!currentManufacturer) return null

              return (
                <div className="flex flex-col ml-25 pl-25 border-l-1 border-gray-200">
                  <img
                    style={{ height: 40 }}
                    src={currentManufacturer.logo}
                    alt={currentManufacturer.name}
                    aria-hidden="true"
                  />
                </div>
              )
            }}
          </Query>
        )}
      </div>

      {authenticated ? (
        <nav className="h-full">
          <ul className="h-full flex flex-row items-center">
            <NavItem linkTo="/calculations">{t('calculation')}</NavItem>
            <NavItem linkTo="/projects">{t('projects')}</NavItem>
            {process.env.REACT_APP_ENV === 'abk' && (
              <NavItem linkTo="/manufacturers">{t('manufacturers')}</NavItem>
            )}
            <NavItem linkTo="/settings">{t('settings')}</NavItem>
            {process.env.REACT_APP_ENV === 'abk' && <NavItem linkTo="/faq">{t('faq')}</NavItem>}
            {process.env.REACT_APP_ENV === 'rigips' && (
              <NavItem linkTo="/help">{t('help')}</NavItem>
            )}
            <NavItem isLogout>{t('logout')}</NavItem>
          </ul>
        </nav>
      ) : (
        <nav className="h-full">
          <ul className="h-full flex flex-row items-center">
            {process.env.REACT_APP_ENV === 'abk' && <NavItem linkTo="/faq">{t('faq')}</NavItem>}
            {process.env.REACT_APP_ENV === 'rigips' && (
              <NavItem linkTo="/help">{t('help')}</NavItem>
            )}
          </ul>
        </nav>
      )}
    </header>
  )
}

const mapStateToProps = (state: RigipsStore) => {
  const {
    auth: { authenticated },
  } = state
  return { authenticated }
}

export default connect(mapStateToProps)(withRouter(Navigation))
